module.exports = "<div id=\"snackbar\">{{message | translate}}</div>\n"